/** Options d'un <select> à partir d'une table code → libellé. */
export function LabelOptions({ labels }: { labels: Record<string, string> }) {
  return (
    <>
      {Object.entries(labels).map(([value, label]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </>
  );
}
